/**
 * Language-neutral category value stored on the backend when a post is marked
 * as an Amtliche Meldung. The backend stores this fixed string;
 * the client localizes it for display via `getPostCategoryLabel`.
 */
export const AMTLICHE_MELDUNG_POST_CATEGORY = 'official';
